import styled from 'styled-components';
import months from 'consts/constants';
import { commonTooltipOptions } from 'consts/chartOptions';
import { chartColor, color } from 'asserts/styles/colors';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

interface ChartDataProps {
  posture?: number[];
  rom?: number[];
  totalData?: number[];
}

const MonthlyStatisticsChart = ({ posture, rom, totalData }: ChartDataProps) => {
  // 차트 양옆으로 여백을 주기 위한 array
  // chart.js 옵션을 찾을 수 없어 아래와 같은 방법 사용
  const updatedLabels = ['', '', ...months, '', ''];
  const chartDataWithNull = (data: number[]) => [null, null, ...data, null, null];

  const data = {
    labels: updatedLabels,
    datasets: [
      {
        label: 'Posture',
        data: posture && chartDataWithNull(posture),
        backgroundColor: `${chartColor.graphGreen}`,
        borderColor: `${color.bgDashBoard}`,
        borderWidth: 2,
        barThickness: 10
      },
      {
        label: 'ROM',
        data: rom && chartDataWithNull(rom),
        backgroundColor: `${chartColor.graphYellow}`,
        borderColor: `${color.bgDashBoard}`,
        borderWidth: 2,
        barThickness: 10
      },
      {
        label: 'Total',
        data: totalData && chartDataWithNull(totalData),
        backgroundColor: `${chartColor.graphMobile}`,
        borderColor: `${color.bgDashBoard}`,
        borderWidth: 2,
        barThickness: 10
      }
    ]
  };

  const options = {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false
      },
      tooltip: commonTooltipOptions
    },

    scales: {
      x: {
        grid: {
          display: false
        },
        ticks: {
          font: {
            size: 13,
            family: 'Noto Sans KR'
          }
        }
      },
      y: {
        grid: {
          color: `${color.white01}`
        },
        ticks: {
          font: {
            family: 'Noto Sans KR'
          }
        }
      }
    }
  };

  return (
    <Wrapper>
      <Bar data={data} options={options} />
    </Wrapper>
  );
};

export default MonthlyStatisticsChart;

const Wrapper = styled.div`
  height: 267px;
  margin-top: 34px;
`;
